/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".wrapper[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;position:relative}.loader[_ngcontent-%COMP%]{background-color:#333;opacity:.7;position:absolute;left:0;top:0;width:100%;height:100%;display:none;align-items:center;justify-content:center;color:#fff}"];
export { styles as styles };
